import styled from 'styled-components';
import Text14 from '@sdk/components/ui/typography/Text14';

export const PricingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
`;

export const PricingSummaryText = styled(Text14)`
  color: ${({ theme }) => theme.colors.gray};
`;
